<div class="dx-field">
  <dx-radio-group [items]="options"
                [(value)]="selectedId"
                valueExpr="id"
                displayExpr="name"
                layout="vertical">
</dx-radio-group>
</div>
